var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loginFormIsVisible
        ? _c("rb-login-form", {
            attrs: { "is-frame-advisor": _vm.isFrameAdvisor },
            on: {
              showRegisterForm: _vm.showRegisterForm,
              close: _vm.handleCloseLoginForm,
            },
          })
        : _c("rb-register-form", {
            attrs: { "is-frame-advisor": _vm.isFrameAdvisor },
            on: { showLoginForm: _vm.showLoginForm },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }